import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import imageUpload from "components/imageUpload.vue";
import { ContainerMixin, ElementMixin, HandleDirective } from "vue-slicksort";
var SortableList = {
  name: "sortablelist",
  mixins: [ContainerMixin],
  template: "\n    <ul class=\"sortable-list\">\n      <slot />\n    </ul>\n  "
};
var SortableItem = {
  name: "sortableitem",
  mixins: [ElementMixin],
  template: "\n    <li class=\"sortable-list-item\">\n      <slot />\n    </li>\n  "
};
export default {
  data: function data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,

      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      industryField: "",
      elevel: "",
      ishot: 0,
      pulishTime: "",
      companyName: "",
      jobsName: "",
      phone: "",
      needProvince: "",
      needNumber: "",
      abilityRequirements: "",
      majorRequirements: "",
      note: "",
      salaryInfo: "",

      /* --------------------------------------- */
      id: "",
      ids: [],
      cName: "",
      options: [{
        label: "高职",
        value: 1
      }, {
        label: "中职",
        value: 2
      }],
      value: "",
      needJobsId: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      // 排序
      openOrderVisible: false,
      sortList: [],
      newList: [],
      SourceIds: []
    };
  },
  components: {
    imageUpload: imageUpload,
    SortableList: SortableList,
    SortableItem: SortableItem
  },
  created: function created() {
    this.school = this.$store.state.auth.userName;
    this.getJobsList();
  },
  methods: {
    openOrder: function openOrder() {
      var _this = this;

      this.$http.post("/api/XOrg/JobsNeedManager/getAllJobsList", {}).then(function (rst) {
        if (rst.code == 1) {
          _this.sortList = rst.list;
          _this.openOrderVisible = true;
        } else {
          _this.$message.warning(rst.msg);
        }
      });
    },
    closeOrder: function closeOrder() {
      this.openOrderVisible = false;
      this.sortList = [];
      this.newList = [];
    },
    submitOrder: function submitOrder() {
      var _this2 = this;

      var arr = this.newList;
      this.$http.post("/api/XOrg/JobsNeedManager/sortNum", {
        ids: this.newList
      }).then(function (rst) {
        if (rst.code == 1) {
          _this2.getJobsList();

          _this2.closeOrder();

          _this2.$message.success(rst.msg);
        } else {
          _this2.$message.warning(rst.msg);
        }
      });
    },
    onInput: function onInput(newList) {
      var classIds = [];

      for (var i = 0; i < newList.length; i++) {
        classIds[i] = newList[i].id;
      }

      ;
      this.newList = classIds;
    },
    getJobsList: function getJobsList(page) {
      var _this3 = this;

      var that = this;
      this.$http.post("/api/XOrg/JobsNeedManager/getJobsList", {
        page: page,
        pageSize: this.pageSize,
        cName: that.cName,
        ETyoe: that.value
      }).then(function (rst) {
        if (rst.code == 1) {
          _this3.list = rst.list;
          _this3.total = rst.pagination.totalCount;
          _this3.pageSize = rst.pagination.pageSize;
          _this3.pageIndex = rst.pagination.pageIndex;
        } else {
          _this3.$message.warning(rst.msg);
        }
      });
    },
    onPageChangeHandler: function onPageChangeHandler(page) {
      this.getJobsList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getJobsList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this4 = this;

      this.ids = [];
      val.forEach(function (element) {
        _this4.ids.push(element.id);
      });
    },
    cancel: function cancel() {
      this.addNewNoticeVisible = false, this.editNoticeVisible = false, this.viewNoticeVisible = false, this.industryField = "", this.elevel = "", this.salaryInfo = "", this.companyName = "", this.jobsName = "", this.phone = "", this.needProvince = "", this.needNumber = "", this.abilityRequirements = "", this.majorRequirements = "", this.note = "", this.ishot = 0, this.pulishTime = "";
    },
    addJobs: function addJobs() {
      var that = this;
      this.$http.post("/api/XOrg/JobsNeedManager/addJobs", {
        industryField: that.industryField,
        elevel: that.elevel,
        salaryInfo: that.salaryInfo,
        isHot: that.ishot,
        pulishTime: that.pulishTime,
        companyName: that.companyName,
        jobsName: that.jobsName,
        phone: that.phone,
        needProvince: that.needProvince,
        needNumber: that.needNumber,
        abilityRequirements: that.abilityRequirements,
        majorRequirements: that.majorRequirements,
        note: that.note
      }).then(function (rst) {
        if (rst.code === 1) {
          that.cancel();
          that.$message({
            showClose: true,
            message: rst.msg,
            type: "success"
          });
          that.getJobsList();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    viewSchoolNews: function viewSchoolNews(row) {
      this.industryField = row.industryField;
      this.elevel = row.elevel;
      this.salaryInfo = row.salaryInfo;
      this.ishot = row.ishot;
      this.pulishTime = row.pulishTime;
      this.companyName = row.companyName;
      this.jobsName = row.jobsName;
      this.phone = row.phone;
      this.needProvince = row.needProvince;
      this.needNumber = row.needNumber;
      this.abilityRequirements = row.abilityRequirements;
      this.majorRequirements = row.majorRequirements;
      this.note = row.note;
      this.viewNoticeVisible = true;
    },
    editNeedJobs: function editNeedJobs() {
      var that = this;
      this.$http.post("/api/XOrg/JobsNeedManager/editJobs", {
        id: that.needJobsId,
        industryField: that.industryField,
        elevel: that.elevel,
        salaryInfo: that.salaryInfo,
        isHot: that.ishot,
        pulishTime: that.pulishTime,
        companyName: that.companyName,
        jobsName: that.jobsName,
        phone: that.phone,
        needProvince: that.needProvince,
        needNumber: that.needNumber,
        abilityRequirements: that.abilityRequirements,
        majorRequirements: that.majorRequirements,
        note: that.note
      }).then(function (rst) {
        if (rst.code === 1) {
          that.cancel();
          that.$message({
            message: rst.msg,
            type: "success"
          });
          that.editNoticeVisible = false;
          that.getJobsList();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    add: function add() {
      this.addNewNoticeVisible = true;
    },
    edit: function edit(row) {
      this.industryField = row.industryField;
      this.elevel = row.elevel;
      this.salaryInfo = row.salaryInfo;
      this.ishot = row.isHot;
      this.pulishTime = row.pulishTime;
      this.companyName = row.companyName;
      this.needJobsId = row.id;
      this.jobsName = row.jobsName;
      this.phone = row.phone;
      this.needProvince = row.needProvince;
      this.needNumber = row.needNumber;
      this.abilityRequirements = row.abilityRequirements;
      this.majorRequirements = row.majorRequirements;
      this.note = row.note;
      this.editNoticeVisible = true;
    },
    deleteMajor: function deleteMajor(id) {
      var _this5 = this;

      this.$confirm("此操作将删除该岗位信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        // this.DeleteSchoolNews(id)
        var that = _this5;

        _this5.$http.post("/api/XOrg/JobsNeedManager/deleteNews", {
          jobsIds: id
        }).then(function (rst) {
          if (rst.code === 1) {
            that.$message({
              message: rst.msg,
              type: "success"
            });
            that.getJobsList();
          }
        });
      }).catch(function () {
        _this5.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    search: function search() {
      this.getJobsList(1);
    },
    deleteAll: function deleteAll() {
      var _this6 = this;

      if (this.ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择岗位信息",
          type: "warning"
        });
        return false;
      }

      this.$confirm("此操作将删除所选岗位信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        // DeleteSchoolNews(this.ids)
        var that = _this6;

        _this6.$http.post("/api/XOrg/JobsNeedManager/deleteNews", {
          jobsIds: that.ids
        }).then(function (rst) {
          if (rst.code === 1) {
            _this6.$message({
              message: rst.msg,
              type: "success"
            });

            _this6.getJobsList();
          }
        });
      }).catch(function () {
        _this6.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    }
  }
};